import React, { ReactElement, useEffect, useState } from 'react';
import './Winners.scss';
import _ from 'lodash';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

interface PrizeList {
  playstation: Pick<any, string | number | symbol>[];
  headphones: Pick<any, string | number | symbol>[];
}

const Winners: React.FC = (): ReactElement => {
  const { t } = useTranslation();

  const [winners, setWinners] = useState<PrizeList>({
    playstation: [],
    headphones: [],
  });

  const getWinners = async () => {
    const res = await axios.get('/api/dataservice/winners/');

    // console.log(res);
    const prizes = _.mapValues(_.groupBy(res.data, 'prize'), (plist) =>
      plist.map((prize) => _.omit(prize, 'prize')),
    );

    setWinners({
      playstation: prizes.playstation === undefined ? [] : prizes.playstation,
      headphones: prizes.headphones === undefined ? [] : prizes.headphones,
    });
  };

  useEffect(() => {
    getWinners();
  }, []);

  return (
    <div className="winners">
      <h2>{t('winners')}</h2>
      <div className="winners-wrapper columns">
        <div className="column">
          <ul className={winners.playstation.length === 0 ? 'hidden' : ''}>
            <li className="prize-name">Sony PS5 Pro</li>
            {winners.playstation.map(function (item: any, index: any) {
              return (
                <li key={index}>{item.first_name + ' ' + item.last_name}</li>
              );
            })}
            {/*<li>name name</li> */}
          </ul>
          <ul className={winners.headphones.length === 0 ? 'hidden' : ''}>
            <li className="prize-name">Sony kõrvaklapid</li>
            {winners.headphones.map(function (item: any, index: any) {
              return (
                <li key={index}>{item.first_name + ' ' + item.last_name}</li>
              );
            })}
            {/*<li>name name</li> */}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Winners;
